import {sessionService} from 'redux-react-session'
import store from '../redux/Store'
import {history} from './History'
import Objects from "../redux/Objects";
import {set} from "../redux/Action";
import {profile, refreshToken} from "../utils/API";

export function startSession() {
    sessionService.initSessionService(store, {driver: 'LOCALSTORAGE'})

    sessionService.loadSession().then(currentSession => {
        if (!currentSession[Objects.token]) {

            window.sessionLoaded = true
            window.userLogin = false
            if (window.location.pathname.startsWith('/hom'))
                history.push('/hom/login')
            return
        }

        store.dispatch(set(Objects.token, currentSession[Objects.token]))
        store.dispatch(set(Objects.profile, currentSession[Objects.profile]))
        store.dispatch(set(Objects.tutorEnv, currentSession[Objects.tutorEnv]))

        window.sessionLoaded = true
        window.userLogin = true

        refreshToken((res) => {
            store.dispatch(set(Objects.token, res))
            sessionUpdate(Objects.token, res)
        })


        profile((res) => {
            store.dispatch(set(Objects.profile, res))
            sessionUpdate(Objects.profile, res)
        }, () => {
            store.dispatch(set(Objects.profile, currentSession[Objects.profile]))
        })
    }).catch(err => {
        window.sessionLoaded = true
        window.userLogin = false
        if (window.location.pathname.startsWith('/hom'))
            history.push('/hom/login')
    });
}

export function sessionDestroy() {
    sessionService.deleteSession().then(() => {
        document.cookie = "expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.href = '/hom/login'
    })
}

export function sessionAdd(key, value) {
    sessionService.loadSession().then(currentSession => {
        let newSession = {
            ...currentSession,
            [key]: value
        }
        sessionService.saveSession(newSession)
    }).catch(err => {
        sessionService.saveSession({[key]: value})
    });
}

export function sessionAddMulti(params) {
    sessionService.loadSession().then(currentSession => {
        let newSession = {
            ...currentSession,
            ...params
        }
        sessionService.saveSession(newSession)
    }).catch(err => {
        sessionService.saveSession(params)
    });
}

export function sessionUpdate(key, value) {
    store.dispatch(set(key, value))

    sessionService.loadSession().then(currentSession => {
        delete currentSession[key]
        let newSession = {
            ...currentSession,
            [key]: value
        }
        sessionService.saveSession(newSession)
    }).catch(err => {
        sessionService.saveSession({[key]: value})
    });
}

export function sessionRemove(key) {
    sessionService.loadSession().then(currentSession => {
        delete currentSession[key]
        sessionService.saveSession(currentSession)
    }).catch(err => {
    });
}
